import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion/dist/framer-motion";
import confetti from "canvas-confetti";
import Typewriter from "../components/Typewriter";
import { GALLERY_PHOTOS } from "../photoManifest";
import { FINALE_TITLE, FINALE_LETTER, FINALE_SIGNOFF, FINALE_FROM } from "../MothersDayData";
import { useGame } from "../GameState";

const ACHIEVEMENT_LABELS = {
  catcher: "🏆 Heart Catcher",
  combo10: "🔥 Combo King",
  noHit: "🛡 Untouchable",
  puzzler: "🧩 Memory Architect",
  efficient: "⚡ Efficient Mind",
  matcher: "🎴 Memory Master",
  perfectMemory: "💎 Perfect Recall",
  reachedMama: "✈ Reached Mama",
};

const FAMILY_FINALE = process.env.PUBLIC_URL + "/mothersday/family-yellow.jpg";

const fireFinaleConfetti = () => {
  const end = Date.now() + 4000;
  const colors = ["#ff6b9d", "#c44569", "#ffd93d", "#ff1493", "#ffa07a", "#9b59b6"];
  (function frame() {
    confetti({ particleCount: 5, angle: 60, spread: 60, origin: { x: 0, y: 0.7 }, colors });
    confetti({ particleCount: 5, angle: 120, spread: 60, origin: { x: 1, y: 0.7 }, colors });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
};

const CAROUSEL = [FAMILY_FINALE, ...GALLERY_PHOTOS.slice(0, 8)];

const FinaleAct = ({ onReplay }) => {
  const { state } = useGame();
  const [photoIdx, setPhotoIdx] = useState(0);
  const [letterDone, setLetterDone] = useState(false);

  useEffect(() => {
    fireFinaleConfetti();
    const t = setTimeout(fireFinaleConfetti, 2200);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const i = setInterval(() => setPhotoIdx((p) => (p + 1) % CAROUSEL.length), 4200);
    return () => clearInterval(i);
  }, []);

  return (
    <motion.div
      className="md-act md-act-finale"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.7 }}
    >
      <motion.div
        className="md-finale-card"
        initial={{ scale: 0.94, y: 16, opacity: 0 }}
        animate={{ scale: 1, y: 0, opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.7, type: "spring", stiffness: 120 }}
      >
        <div className="md-finale-photo-wrap">
          {CAROUSEL.map((src, i) => (
            <motion.div
              key={src}
              className="md-finale-photo"
              style={{ backgroundImage: `url(${src})` }}
              initial={false}
              animate={{ opacity: i === photoIdx ? 1 : 0, scale: i === photoIdx ? 1 : 1.06 }}
              transition={{ duration: 1.2, ease: "easeInOut" }}
            />
          ))}
          <div className="md-finale-photo-counter">{photoIdx + 1} / {CAROUSEL.length}</div>
        </div>

        <div className="md-letter">
          <h2>{FINALE_TITLE}</h2>
          <div className="md-letter-body">
            <Typewriter lines={FINALE_LETTER} speed={26} lineDelay={180} onDone={() => setLetterDone(true)} />
          </div>
          <motion.div
            className="md-signoff"
            initial={{ opacity: 0 }}
            animate={{ opacity: letterDone ? 1 : 0 }}
            transition={{ duration: 0.6 }}
          >
            {FINALE_SIGNOFF}
          </motion.div>
          <motion.div
            className="md-from"
            initial={{ opacity: 0 }}
            animate={{ opacity: letterDone ? 1 : 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
          >
            {FINALE_FROM}
          </motion.div>

          {state.achievements.length > 0 && (
            <motion.div
              className="md-final-achievements"
              initial={{ opacity: 0 }}
              animate={{ opacity: letterDone ? 1 : 0 }}
              transition={{ delay: 0.5 }}
            >
              <div className="md-final-stats">
                <div><span>Total score</span><strong>{state.totalScore}</strong></div>
                <div><span>Best ever</span><strong>{state.bestScore}</strong></div>
                <div><span>Levels</span><strong>{state.levelsCleared.length} / 4</strong></div>
              </div>
              <div className="md-final-badges">
                {state.achievements.map((a) => (
                  <span key={a} className="md-badge-chip">{ACHIEVEMENT_LABELS[a] || a}</span>
                ))}
              </div>
            </motion.div>
          )}

          <motion.div
            className="md-finale-actions"
            initial={{ opacity: 0 }}
            animate={{ opacity: letterDone ? 1 : 0 }}
            transition={{ delay: 0.7 }}
          >
            <button className="md-btn-soft md-btn-ghost" onClick={onReplay}>
              ↻ Play again
            </button>
            <Link to="/" className="md-btn-soft" style={{ textDecoration: "none" }}>
              Papa's site →
            </Link>
          </motion.div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default FinaleAct;
